import { useQueryClient } from 'react-query';

import { socketEvents } from 'shared/constants';
import { useSocketSubscribe } from 'shared/hooks/useSocketSubscribe';

export const useSkillTaxonomiesSocket = (queryKey: (string | number)[]) => {
  const queryClient = useQueryClient();

  const invalidateQueries = () => {
    queryClient.invalidateQueries({ queryKey });
  };

  useSocketSubscribe(socketEvents.skillTaxonomyCreated, invalidateQueries);
  useSocketSubscribe(socketEvents.skillTaxonomyUpdated, invalidateQueries);
  useSocketSubscribe(socketEvents.skillTaxonomyDeleted, invalidateQueries);
};
